module.exports = __webpack_public_path__ + "static/img/cont214.6e807ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont214.jpg
// module id = g1YZ
// module chunks = 0